// Existing tenants keep their current behavior unless explicitly disabled.
export const NOTI_BYPASS_ENABLED = process.env.REACT_APP_NOTI_BYPASS_ENABLED !== 'false';

export const VERITASON_AGENT_WALLET_TRANSFER_ENABLED = process.env.REACT_APP_VERITASON_AGENT_WALLET_TRANSFER_ENABLED === 'true';

// Earnings dashboard is opt-in per build; wallet access remains independent.
export const AGENT_DASHBOARD_ENABLED = process.env.REACT_APP_AGENT_DASHBOARD_ENABLED === 'true';

// Explicit opt-in: brand fallback alone must not enable this on other builds.
export const CONFIRMED_HOLD_ENABLED = process.env.REACT_APP_HOST_BRAND === 'fast'
    && process.env.REACT_APP_CONFIRMED_HOLD_ENABLED === 'true';

// PIN-only adapter capability; server DB policy controls authentication.
export const PIN_POLICY_ENABLED = process.env.REACT_APP_PIN_POLICY_ENABLED === 'true';

// Merchant policy UI; independent of credential reset and 01 transfer control.
export const MERCHANT_PIN_POLICY_ADMIN_ENABLED = process.env.REACT_APP_MERCHANT_PIN_POLICY_ADMIN_ENABLED === 'true';

// Enable only after the agent PIN backend is installed. Policy errors never mean OFF.
export const AGENT_PIN_ENABLED = process.env.REACT_APP_AGENT_PIN_ENABLED === 'true';

// Administrator policy UI is independent of agent authentication rollout.
export const AGENT_PIN_ADMIN_ENABLED = process.env.REACT_APP_AGENT_PIN_ADMIN_ENABLED === 'true';

export const MERCHANT_TRANSFER_CONTROL_ENABLED = process.env.REACT_APP_MERCHANT_TRANSFER_CONTROL_ENABLED === 'true';
